import gql from 'graphql-tag';

export const CREATE_MACHINE = gql`
	mutation createMachineMutation($input: CreateMachineInput!) {
		createMachine(input: $input) {
			id
			place {
				id
				name
			}
			type
			assetId
			brand
			location {
				id
				name
			}
		}
	}
`;

